import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'
function MfWhatsInOut() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [type, settype] = useState('In');
    const [DataMfHoldingdropMfcode, setDataMfHoldingdropMfcode] = useState([]);
    const [CategorymfCode, setCategoryDividend] = useState('5946');
    const [valueschemename, setValueschemename] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getDataHoldingdrop,PageSize = 5;
    let navigate = useNavigate();

    
    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";
        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHoldingdrop = dataMHolding.data;
                setDataMfHoldingdropMfcode(getDataHoldingdrop);
                var schemename = getDataHoldingdrop[0].co_name;
                setValueschemename(schemename)
                setloadingshow(false);
                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "WhatsInOutUnchanged";
        // alert(`${getUrl}/${type}/${CategorymfCode}`)
        fetch(`${getUrl}/fund/${type}/${CategorymfCode}/8`)
            .then((response) => response.json())
            .then((data) => {

                setData(data.data);
                setloadingshow(false);
            })
            .catch((error) => {
                //console.log("not found the api");
            });



    }, [type, CategorymfCode]);

    // const currentTableData = useMemo(() => {
    //     if (data != null && data != []) {
    //         const firstPageIndex = (currentPage - 1) * PageSize;
    //         const lastPageIndex = firstPageIndex + PageSize;
    //         if (data != null && data != []) {
    //             if (data.length > 0) {
    //                 return data.slice(firstPageIndex, lastPageIndex);
    //             }
    //         }
    //     }
    // }, [currentPage, data]);

    const handleSelect = (key) => {
        if (key === "whatin")
            settype('In');
        else
            settype('Out');
    }
    return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>What’s In /Out</h4>
                    <span className="moreContent" onClick={()=>{navigate("/MutualFund/What's-In-and-Out")}}>See More</span>
                </div>
                <Container className="add-border table-box">
                <div className='ipo-common mf-common'>
                    <div className='whatsin-select'>
                        
                        {/* aria-label="Select Fund House" */}
                        <select aria-label="Select Fund House" onChange={(event) => setCategoryDividend(event.target.value)}>
                            <option>Select Fund House</option>
                            {DataMfHoldingdropMfcode && DataMfHoldingdropMfcode.map(
                                ({ mf_cocode, co_name }) => (
                                    <option value={mf_cocode} selected={valueschemename === co_name}>{co_name}</option>
                                )
                            )}
                        </select>
                    </div>
                    <Tabs defaultActiveKey="whatin"
                        transition={true}
                        id="noanim-tab-example"
                        className="mb-3 MF" onSelect={(e) => handleSelect(e)}>
                        <Tab eventKey="whatin" title="What's In">
                            <div className='mf-table table-responsive gainer-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>No. Of Shares</th>
                                            <th className='text-right'>Market Value(in Cr.)  </th>
                                        </tr>
                                    </thead>
                                   
                                    <tbody>
                                    
                                    {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                    {(data != null) && data.map(({ CO_NAME,NO_SHARES,mktvalue}) => (
                                        <tr>
                                            <td className='text-left'>{CO_NAME}</td>
                                            <td className='text-right'>{NO_SHARES}</td>
                                            <td className='text-right'>{mktvalue.toFixed(2)}</td>
                                        </tr>
                                         ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                {/* {(data != null && data != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(data.length != null) ? data.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                            </div>
                        </Tab>
                        <Tab eventKey="whatout" title="What's Out">
                        <div className='mf-table table-responsive gainer-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>No. Of Shares</th>
                                            <th className='text-right'>Market Value(in Cr.)</th>
                                        </tr>
                                    </thead>
                                  
                                    <tbody>
                                   
                                    {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                    {(data != null) && data.map(({ CO_NAME,NO_SHARES,mktvalue}) => (
                                        <tr>
                                            <td className='text-left'>{CO_NAME}</td>
                                            <td className='text-right'>{NO_SHARES}</td>
                                            <td className='text-right'>{mktvalue.toFixed(2)}</td>
                                        </tr>
                                         ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                {/* {(data != null && data != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(data.length != null) ? data.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                            </div>
                        </Tab>
                    </Tabs>
                </div>
                </Container>
            </div>
        </>
    )
}

export default MfWhatsInOut